<template>
	<div class="vip_set">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">VIP</p>
			</h1>
		</header>
		<p class="vip_a">您尚未开通VIP</p>
		<p class="vip_b">申请开通VIP后，可以免费看全部内容</p>
		<p 
			id="vip_c" 
			v-for="(itm,index) in vip" 
			:class="{'active':ind == index}"
			v-on:click="cvip(itm.vp_price,itm.vp_name,itm.desc,index)"
		>￥{{itm.vp_price}}/{{itm.vp_name}}{{itm.desc}}</p>

		<button class="vip_g" v-on:click="setvip()">开通VIP</button>
		<div class="tc_nav">
            <span class="tc_navx"></span>
        </div>
	</div>
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
data() {
return {
  vip:[],
  date_price:[],
  ind:0
}
},
mounted(){
	this.getAjax();
},
methods:{
	cvip:function(vp_price,vp_name,desc,index){
		this.ind = index
		if(desc == undefined || desc == null ){
			desc = ''
		}
		this.date_price={vp_price,vp_name,desc}
	},

	callpay:function(params){
		
        if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady',this.jsApiCall(params), false);
            }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady',this.jsApiCall(params)); 
                document.attachEvent('onWeixinJSBridgeReady',this.jsApiCall(params));
            }
        }else{
             this.jsApiCall(params);
        }
    },
    jsApiCall:function (params){   
    	var that = this;
        WeixinJSBridge.invoke(
              'getBrandWCPayRequest',{
              'appId': params.appId, // 公众号名称，由商户传入
              'timeStamp': params.timeStamp, // 时间戳，自1970年以来的秒数
              'nonceStr': params.nonceStr, // 随机串
              'package': params.package,
              'signType': params.signType, // 微信签名方式：
              'paySign': params.paySign, // 微信签名
          },
            function(res){
                WeixinJSBridge.log(res.err_msg);
                if (res.err_msg == "get_brand_wcpay_request:ok") {
//                  location.href = '/mine';    
                    that.$router.push({path:'/mine'});
                }else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                  $('.tc_navx').text('支付已取消')
                    $('.tc_nav').fadeIn()
                    setTimeout(function(){
                        $('.tc_nav').fadeOut()
                    },1000)
                }else{
                  $('.tc_navx').text('支付失败')
                    $('.tc_nav').fadeIn()
                    setTimeout(function(){
                        $('.tc_nav').fadeOut()
                    },1000)
                }
            }
        );
    },
	setvip:function(){
	if(this.date_price == undefined || this.date_price == null || this.date_price == '' || this.date_price == NaN){
		var vp_price = this.vip[0].vp_price
		var vp_name = this.vip[0].vp_name
		var desc = this.vip[0].desc
		this.date_price={vp_price,vp_name,desc}
	}
	var openid=localStorage.getItem("openid");
	var successCallback =  (response) => {
        console.log(response.data)
        if(response.status==200){
            this.callpay(response.data);
        }else{
            $('.tc_navx').text(response.msg)
            $('.tc_nav').fadeIn()
            setTimeout(function(){
                $('.tc_nav').fadeOut()
            },2000)
        }
    }
	var errorCallback =  (response) => {
      console.log('服务器请求出错了')
  	}
    this.$http.get(CURL+'/user/wxpay/vip_pay?money='+this.date_price.vp_price+'&vipname='+this.date_price.vp_name+this.date_price.desc+'&openid='+openid).then(successCallback,errorCallback);
	},
	getAjax:function () {
   	var successCallback =  (response) => {
    	console.log('success')
    	this.vip=response.vip
    	for(var i=0;i<this.vip.length;i++){
	    	if(this.vip[i].vp_status == 1){
	    		this.vip[i]['desc']='天'
	    	}else if(this.vip[i].vp_status == 2){
	    		this.vip[i]['desc']='月'
	    	}else if(this.vip[i].vp_status == 3){
	    		this.vip[i]['desc']='年'
	    	}
    	}
    }
    var errorCallback =  (response) => {
        console.log('error')
    }
    this.$http.get(CURL+'/portal/All/getvip').then(successCallback,errorCallback);
  	},
}
}


</script>
<style lang="scss" scoped>
.tc_navx{
    background-color: #00a8d9;
    border-radius: 5px;
    padding: 10px 20px 10px 20px;
}
.tc_nav{
    display: none;
    position: fixed;
    margin-left: 20%;
    text-align: center;
    width: 60%;
/*  height: 30px;*/
    color: #ffffff;
    font-size: 15px;
    bottom: 70%;
}
.active{
	color:#00a8d9!important;
	border:#00a8d9 solid 1px!important;
}

/*cont*/
.vip_g{
	width: 80%;
	float: left;
	margin: 60px 10% 0 10%;
	padding: 15px 0 15px 0;
	background:url(../../img/ss.png);
  background-size: cover 100% 100%;
  background-repeat: no-repeat;
	border-radius: 5px;
	color: #FFFFFF;
	font-size: 15px;
	font-weight: 600;
}
#vip_c{
	margin: 0;
	margin-top: 40px;
	width: 41%;
	border: #777 solid 1px;
	color: #777;
	height: 40px;
	line-height: 40px;
}
#vip_c{
	margin-left: 6%;
}
#vip_e{
	margin-right: 1%;
}
.vip_a{
	color: red;
	font-weight: 600;
}
.vip_a,.vip_b{
	background-color: #f5f5f5;
	padding: 15px 0 15px 0;
	margin-top: 20px;
}
p{
	margin-left: 5%;
	margin-right: 5%;
	width: 90%;
	float: left;
	text-align: center;
	border-radius: 7px;
}
/*head*/
header{
  height: .4rem;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  float: left;
  width: 100%;
  h1{
    margin-top: .2rem;
  }
}
.set_1{
  text-align: center;
    float: left;
    width: 86%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height:0;
}
.set_2{
  float: left;
  margin-left: 3%;
  margin-top: -7px;
  width: 5%;
  color: #FFFFFF;
}
/*xxxx*/
.vip_set{
	width: 100%;
	float: left;
  background-color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/vip.vue